import http from "../http-common";

const getProfile = () => {
  return http.get('/users/profile', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,
    },
  });
};

const updateProfile = (data) => {
  return http.put('/users/profile', data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,
    },
  });
};

const changePassword = (data) => {
  return http.post('/users/change-password', data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,
    },
  });
};

const ProfileService = {
  getProfile,
  updateProfile,
  changePassword,
};

export default ProfileService;
